<pas-button-round
  [color]="pasButtonRoundColor.DARK"
  (click)="onDetailClicked()"
  id="approvalOverviewDetailBtn"
  title="{{'APPROVAL_TABLE_DETAILS_BUTTON' | translate}}"
  icon="search"
  size="small"></pas-button-round>
@if (canUserApprove()) { @if (isValid()) {
<pas-button-round
  [color]="pasButtonRoundColor.DARK"
  (click)="onApproveClicked()"
  id="approvalOverviewApproveBtn"
  title="{{'APPROVAL_TABLE_APPROVE_BUTTON' | translate}}"
  icon="check"
  size="small"></pas-button-round>
} @if (isValid()) {
<pas-button-round
  [color]="pasButtonRoundColor.DARK"
  (click)="onRejectClicked()"
  id="approvalOverviewRejectBtn"
  title="{{'APPROVAL_TABLE_REJECT_BUTTON' | translate}}"
  icon="clear"
  size="small"></pas-button-round>
} }

<approve-reject-reprocess-dialog></approve-reject-reprocess-dialog>
